export default "__VITE_ASSET__D428$e1m__"